// CRM, Kanban e Agenda passam pelo Rails (/ms/...), que confere a sessão, põe a chave
// do microserviço e decide conta e usuário. O navegador não conhece a chave nem escolhe
// a conta: antes a chave ia gravada no JavaScript público.
export const msBaseUrl = (servico, accountId) =>
  `/api/v1/accounts/${accountId}/ms/${servico}`;

// A Agenda não recebe a conta como parâmetro: vem da rota, como no ApiClient.
export const accountIdFromRoute = () => {
  const partes = window.location.pathname.split('/');
  return partes[2] === 'accounts' ? partes[3] : '';
};
